import { queryClient } from "App";
import { get } from "lodash";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useMemo, useState } from "react";

import { addResizedColumns } from "hooks/useTableConfig";
import { useSocket } from "providers/SocketProvider";
import { getAgentDashboardTableColumns } from "routes/agent_dashboard/AgentDashboardTableColumnsAndFilters";
import { AGENT_DASHBOARD_TABLE_CONSTANTS } from "routes/agent_dashboard/AgentDashboardTableV3";
import UserService from "services/User";

const filters = [];
export const invalidateAgentDashboardTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [AGENT_DASHBOARD_TABLE_CONSTANTS.queryKey],
  });
};

export const useAgentDashboardTable = () => {
  const { socket } = useSocket();
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });
  const [lastUpdate, setLastUpdate] = useState("");

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getAgentDashboardTableColumns();
    const agentDashboardTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${AGENT_DASHBOARD_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: agentDashboardTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  const handleDashboardUpdate = useCallback(() => {
    invalidateAgentDashboardTableQuery();
    setLastUpdate(moment());
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("agent_dashboard_updated", handleDashboardUpdate);
    }

    return () => {
      if (socket) {
        socket.off("agent_dashboard_updated", handleDashboardUpdate);
      }
    };
  }, [socket, handleDashboardUpdate]);

  return {
    filters,
    columns,
    lastUpdate,
  };
};
